import api from './api';

export const jobsAPI = {
  meta: () => api.get('/api/jobs/meta'),
  migrateEngagements: () => api.post('/api/jobs/migrate-engagements'),
  list: (params) => api.get('/api/jobs', { params }),
  create: (data) => api.post('/api/jobs', data),
  get: (id) => api.get(`/api/jobs/${id}`),
  update: (id, data) => api.patch(`/api/jobs/${id}`, data),
  updateStatus: (id, status) => api.patch(`/api/jobs/${id}/status`, { status }),
  delete: (id) => api.delete(`/api/jobs/${id}`),
  // Permanently delete an already-archived job (owner/admin only, irreversible).
  purge: (id) => api.delete(`/api/jobs/${id}/permanent`),

  // Checklist
  addChecklistItem: (id, label) => api.post(`/api/jobs/${id}/checklist`, { label }),
  updateChecklistItem: (id, itemId, data) => api.patch(`/api/jobs/${id}/checklist/${itemId}`, data),
  deleteChecklistItem: (id, itemId) => api.delete(`/api/jobs/${id}/checklist/${itemId}`),
  checklistTemplate: (jobType) => api.get(`/api/jobs/checklist-template/${jobType}`),
  saveChecklistTemplate: (jobType, labels) => api.put(`/api/jobs/checklist-template/${jobType}`, { labels }),
  resetChecklistTemplate: (jobType) => api.delete(`/api/jobs/checklist-template/${jobType}`),

  // AI review (populates ai_review_status)
  runAIReview: (id) => api.post(`/api/jobs/${id}/ai-review`),

  // Documents linked to a job
  listDocuments: (id) => api.get(`/api/jobs/${id}/documents`),
  linkDocument: (id, documentId) => api.post(`/api/jobs/${id}/documents`, { document_id: documentId }),
  unlinkDocument: (id, documentId) => api.delete(`/api/jobs/${id}/documents/${documentId}`),

  // Notes scoped to a job
  listNotes: (id) => api.get(`/api/jobs/${id}/notes`),
  addNote: (id, data) => api.post(`/api/jobs/${id}/notes`, data),
};

// Human-readable labels for the 14 job types (Module C).
export const JOB_TYPE_LABELS = {
  individual_tax_return: 'Individual Tax Return',
  company_tax_return: 'Company Tax Return',
  trust_tax_return: 'Trust Tax Return',
  partnership_tax_return: 'Partnership Tax Return',
  bas_preparation: 'BAS Preparation',
  gst_review: 'GST Review',
  bookkeeping: 'Bookkeeping',
  payroll_review: 'Payroll Review',
  super_review: 'Superannuation Review',
  asic_annual_review: 'ASIC Annual Review',
  client_onboarding: 'Client Onboarding',
  financial_statements: 'Financial Statements',
  management_reports: 'Management Reports',
  virtual_cfo_review: 'Virtual CFO Review',
};

// Human-readable labels for the 11-stage lifecycle (Module C), in order.
export const JOB_STATUS_LABELS = {
  not_started: 'Not Started',
  waiting_for_client: 'Waiting for Client',
  documents_received: 'Documents Received',
  in_progress: 'In Progress',
  ai_review: 'AI Review in Progress',
  accountant_review: 'Accountant Review',
  partner_review: 'Partner Review',
  ready_for_client_approval: 'Ready for Client Approval',
  ready_to_lodge: 'Ready to Lodge',
  completed: 'Lodged / Completed',
  archived: 'Archived',
};

// Ordered status list for pipeline rendering and progress bars.
export const JOB_STATUS_ORDER = [
  'not_started',
  'waiting_for_client',
  'documents_received',
  'in_progress',
  'ai_review',
  'accountant_review',
  'partner_review',
  'ready_for_client_approval',
  'ready_to_lodge',
  'completed',
  'archived',
];

// Tailwind classes per status badge.
export const JOB_STATUS_COLORS = {
  not_started: 'bg-muted text-foreground/90 border-border',
  waiting_for_client: 'bg-amber-100 text-amber-700 border-amber-200',
  documents_received: 'bg-sky-100 text-sky-700 border-sky-200',
  in_progress: 'bg-blue-100 text-blue-700 border-blue-200',
  ai_review: 'bg-violet-100 text-violet-700 border-violet-200',
  accountant_review: 'bg-indigo-100 text-indigo-700 border-indigo-200',
  partner_review: 'bg-purple-100 text-purple-700 border-purple-200',
  ready_for_client_approval: 'bg-cyan-100 text-cyan-700 border-cyan-200',
  ready_to_lodge: 'bg-accent text-primary border-primary/20',
  completed: 'bg-green-100 text-green-700 border-green-200',
  archived: 'bg-muted text-muted-foreground border-border',
};

export const JOB_PRIORITY_COLORS = {
  low: 'bg-muted text-foreground/90 border-border',
  medium: 'bg-blue-100 text-blue-700 border-blue-200',
  high: 'bg-orange-100 text-orange-700 border-orange-200',
  urgent: 'bg-red-100 text-red-700 border-red-200',
};
